import { SvrConn } from "../utils/axios/index";

//----------------------------------------------------------------------------------------------------------------------
export const getCargosall = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/cargo/getcargosall");
  } catch (Error) {
    res = Error;
  }
  return res;
};